<div class="receiving-add" *ngIf="readReceivingOption">
  <div class="flex fx-align-space-between-center margin-bottom">
    <h3>{{ pageTitle }}</h3>
    <div>
    </div>
  </div>

  <form [formGroup]="form" class="form">


    <div class="fx-xs-column fx-sm-column fx-row">
      <div class="fx-flex-100 margin-right">
    
        <div *ngIf="isReceivingTableLoading" class="receiving-table-loading-container">
              <mat-progress-spinner diameter="15" mode="indeterminate" color="primary"></mat-progress-spinner>
        </div>

        <div *ngIf="!isReceivingTableLoading && receivingProduct && receivingProduct?.prdID != ''">
          <span class="product-receiving-table-title">{{'receiving.product.title'|translate}}</span>
          <mat-dialog-content class="product-receiving-table">
            <div>
              <p><strong>{{'import.prdCode' | translate}}:</strong> {{ receivingProduct.prdCode }}</p>
              <p><strong>{{'import.prdNameEn'|translate}}:</strong> {{ receivingProduct.prdNameEn }}</p>
              <p><strong>{{'import.prdDescription'|translate}}:</strong> {{ receivingProduct.prdDescription }}</p>
              <p><strong>{{'import.barcodeData'|translate}}:</strong> {{ receivingProduct.barcodeData }}</p>
              <p><strong>{{'products.table.onHand'|translate}}:</strong> {{ receivingProduct.prdTotalOnHand }}</p>
            </div>
          </mat-dialog-content>
        </div>

      </div>
    </div>

    <div class="fx-xs-column fx-sm-column fx-row cover">
      <div class="fx-flex-100 margin-right">
        
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ "receivingProduct" | translate }}</mat-label>
          <input type="text" aria-label="Number" matInput class="productSearchInput" [formControl]="productSearchControl" [matAutocomplete]="auto" [placeholder]="'searchProducts' | translate" #autoTrigger="matAutocompleteTrigger">
        
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="onProductSelection($event.option.id)">
            <mat-option *ngFor="let product of filteredProducts" [value]="product.prdNameEn" [id]="product" >
              <span>{{ product.prdNameEn }}</span>
            </mat-option>
          </mat-autocomplete>
          <div *ngIf="(!filteredProducts || filteredProducts.length === 0) && searchStarted && !data?.storageAddItem" class="add-product-button">
            <button mat-raised-button color="primary" (click)="addNewProduct()">
              {{ "products.add" | translate }}
            </button>
          </div>
        </mat-form-field>

      </div>
    </div>

    <div class="fx-xs-column fx-sm-column fx-row cover">
      <div class="fx-flex-100 margin-right">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ "storages" | translate }}</mat-label>
          <input type="text" aria-label="Number" matInput [formControl]="storageSearchControl"
            [matAutocomplete]="auto2">
          <mat-spinner *ngIf="storagesLoading" diameter="20"></mat-spinner>
          <mat-autocomplete autoActiveFirstOption #auto2="matAutocomplete" (optionSelected)="onStorageSelection($event.option.id)">
            <mat-option *ngFor="let storage of filteredStorages | async" [value]="storage.path"
              [id]="storage.storageStructureID">
              <span>{{ storage.path }}</span>
            </mat-option>
          </mat-autocomplete>
          <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
        </mat-form-field>
      </div>
    </div>
    <div class="fx-xs-column fx-sm-column fx-row cover" *ngIf="isSerialized">
      <div class="fx-flex-100 margin-right serial-block">
        <span class="serial-block-label">{{ 'serialForm.pageLabel' | translate }}</span>
        <p class="serial-block-hint">{{ (serials.length === 1 ? 'serialForm.pageHintOne' : 'serialForm.pageHint') | translate: { count: serials.length } }}</p>
        <ng-container *ngFor="let key of [serialFormKey]">
          <app-serial-form variant="receive" [patterns]="serialPatterns" [refused]="serialRefused" [failed]="serialFailed" [disabled]="isSaving"
                           (serialsChange)="onSerialsChange($event)" (blockedChange)="serialsBlocked = $event" (retry)="onSubmit()"></app-serial-form>
        </ng-container>
      </div>
    </div>

    <div class="fx-xs-column fx-sm-column fx-row cover" *ngIf="!isSerialized">
      <div class="fx-flex-100 quantity_box">
        <mat-form-field appearance="outline"  floatLabel="always">
          <mat-label>{{ "receivingQuantity" | translate }}</mat-label>
          <input matInput type="number" formControlName="quantity" onclick="this.select()" />
        </mat-form-field>
      </div>
    </div>

    <div class="fx-xs-column fx-sm-column fx-row cover">
      <div class="fx-flex-100 margin-right">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ 'form.receiving.invoiceNumber' | translate }}</mat-label>
          <input matInput type="text" formControlName="invoice_number" />
        </mat-form-field>
      </div>
    </div>

    <div class="fx-xs-column fx-sm-column fx-row cover">
      <div class="fx-flex-100 margin-right">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ 'form.receiving.poNumber' | translate }}</mat-label>
          <input matInput type="text" formControlName="po_number" />
        </mat-form-field>
      </div>
    </div>

    <div class="fx-xs-column fx-sm-column fx-row cover">
      <div class="fx-flex-100 margin-right">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ 'movement.note' | translate }}</mat-label>
          <input matInput type="text" formControlName="destinationNote" [placeholder]="'movement.notePlaceholder' | translate" />
        </mat-form-field>
      </div>
    </div>

  </form>

  <div class="flex fx-align-space-between-center bottom_update_btn">
    <h3></h3>
    <div>
      <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!form.valid || isSaving || (isSerialized && serialsBlocked)"
        data-test="receiving-add__Submit">
        <ng-container *ngIf="isSerialized && serials.length > 0">{{ (serials.length === 1 ? 'serialForm.receiveUnitsOne' : 'serialForm.receiveUnits') | translate: { count: serials.length } }}</ng-container>
        <ng-container *ngIf="!(isSerialized && serials.length > 0)">{{ pageTitle }}</ng-container>
      </button>
    </div>
  </div>

</div>